import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { UserManagement } from '../components/Settings/UserManagement';
import { OrganizationManagement } from '../components/Settings/OrganizationManagement';
import { LoadingSpinner } from '../components/UI/LoadingSpinner';

export const Settings: React.FC = () => {
  const { loading, isSuperAdmin } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-center">
        <h2 className="text-xl font-semibold text-ink mb-2">
          Acces refuse
        </h2>
        <p className="text-ink-soft">
          Vous n'avez pas les permissions necessaires pour acceder a cette page.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-ink">Parametres</h1>
        <p className="text-ink-soft mt-1">Consultation des utilisateurs et organisations.</p>
      </div>

      <div className="space-y-6">
        <UserManagement />
        <OrganizationManagement />
      </div>
    </div>
  );
};
